import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 28px;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const Content = styled.div`
  display: flex;
  gap: 22px;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const UnsuportedFileDisclaimer = styled.span`
  font-size: 26px;
  font-family: Inter;
  font-weight: 600;
  text-align: center;
  color: #031795;
`;
